import { type ReactElement, createContext } from 'react';

export interface SlabTabListOption<T extends string> {
  label: T;
  count?: number;
}

export interface SlabTabOption<T extends string> {
  label: T;
  count?: number;
  element?: ReactElement;
}

interface SlabTabContextProps<T = string> {
  changeTab(name: T): void;
  activeTab: T;
}

export const SlabTabContext = createContext<SlabTabContextProps>({
  changeTab: () => null,
  activeTab: '',
});
